import type { ReactNode } from "react";
import { Info } from "lucide-react";

import { Label } from "@/components/ui/label";

interface ProjectCreateFieldLabelProps {
  htmlFor: string;
  label: string;
  optionalHint?: string;
}

export function ProjectCreateFieldLabel({
  htmlFor,
  label,
  optionalHint,
}: ProjectCreateFieldLabelProps) {
  return (
    <div className="flex items-baseline gap-1.5">
      <Label htmlFor={htmlFor}>{label}</Label>
      {optionalHint && (
        <span className="text-xs font-normal leading-none text-muted-foreground/70">
          {` · ${optionalHint}`}
        </span>
      )}
    </div>
  );
}

export function ProjectStructureGuidance({ children }: { children: ReactNode }) {
  return (
    <p role="note" className="flex items-start gap-2 text-sm leading-5 text-muted-foreground">
      <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <span>{children}</span>
    </p>
  );
}
